import React, { Component } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { BaseUrl } from "../../helpers/Baseurl"
//Import Charts
import ReactApexChart from 'react-apexcharts';
import "./dashboard.scss";

class RevenueAnalytics extends Component {
    constructor(props) {
        super(props);
        this.state = {
            this_month : 10.0,
            pre_month: 10.0,
            prepre_month:10.0,
            series: [{
                name: 'By Sold Jobs',
                data: [10, 10, 10 ] 
            }],
            month_name:['Jan', "Feb", "Mar"]
            
        };
    }

    componentDidMount () {
        this.loadData()
    }
    async loadData(){

        // const requestOptions = {
        //   method: 'GET',
        //   headers: { 'Content-Type': 'application/json' },
        // };
        // await fetch(`${BaseUrl}/api/jobs/revenue_analysis/`,requestOptions)
        //     .then(res => res.json())
        //     .then(
        //         (data) => {
        //             console.log(data, '-data')
        //             let series= [{
        //                 name: 'By Sold Jobs',
        //                 data: data.months
        //             }
        //         ]
        //             this.setState({ 
        //                 this_month:parseFloat(data.this_month).toFixed(2),
        //                 pre_month: parseFloat(data.pre_month).toFixed(2),
        //                 prepre_month: parseFloat(data.prepre_month).toFixed(2),
        //                 series:series,
        //                 month_name:data.month_name,
        //             })           
                   
        //         },
        //         (error) => {
        //             console.log(error, 'error--------------') 
        //         }
        //     )  
       }


    render() {
       let options = {
            chart: {
                toolbar: {
                    show: false,
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '45%',
                    endingShape: 'rounded'	
                },
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
            },
            
            colors: ['#1cbb8c', '#eeb902','#58a5ff'],
            xaxis: {
                categories: this.state.month_name,
            },
            yaxis: {
                title: {
                    text: '(Actual Selling Price)'
                }
            },
            grid: {
                borderColor: '#f1f1f1',
            },
            fill: {
                opacity: 1
        
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return "$"+  parseFloat(val).toFixed(2)  }
                }
            }
        }
        return (
            <React.Fragment>
                <Card>
                    <CardBody>
                      
                        <h4 className="card-title mb-4">Revenue Analytics</h4>
                        <div>
                            <div id="line-column-chart" className="apex-charts" dir="ltr">
                            <ReactApexChart options={options} series={this.state.series} type="bar" height={350} />
                            </div>
                        </div>
                    </CardBody>

                    <CardBody className="border-top text-center">
                        <Row>
                            <Col sm={4}>
                            <div className="mt-4 mt-sm-0">
                                    <p className="mb-2 text-muted text-truncate">{this.state.month_name[0]} :</p>
                                    {/* <i className="mdi mdi-circle text-success font-size-10 me-1"></i> */}
                                    <div className="d-inline-flex">
                                        <h5 className="mb-0 me-2">$ {this.state.prepre_month}</h5>
                                       
                                    </div>
                                </div>
                               
                            </Col>

                            <Col sm={4}>
                                <div className="mt-4 mt-sm-0">
                                    <p className="mb-2 text-muted text-truncate"> {this.state.month_name[1]} :</p>
                                    <div className="d-inline-flex">
                                        <h5 className="mb-0 me-2">$ {this.state.pre_month}</h5>
                                       
                                    </div>
                                </div>
                            </Col>
                            <Col sm={4}>
                            <div className="mt-4 mt-sm-0">
                                    <p className="mb-2 text-muted text-truncate">{this.state.month_name[2]} :</p>
                                    <div className="d-inline-flex">
                                        <h5 className="mb-0 me-2">$ {this.state.this_month}</h5>
                                       
                                    </div>
                                </div>
                               
                            </Col>

                        </Row>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }
}

export default RevenueAnalytics;